import { createFileRoute } from "@tanstack/react-router";
import ArticlePlacementsManager from "@/pages/admin/ArticlePlacementsManager";

export const Route = createFileRoute("/admin/article-placements")({
  component: ArticlePlacementsManager,
});
